import { createTheme } from "@material-ui/core/styles";
export const theme = createTheme({
  typography: {
    fontFamily: "Univa nova",
    fontSize: 80,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Univa nova';
          font-size: 80px;
        }
      `,
    },
  },
});
